var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.062 2.94a2.631 2.631 0 00-1.857-1.859C17.568.641 11 .641 11 .641s-6.567 0-8.205.438A2.628 2.628 0 00.938 2.938C.5 4.577.5 8 .5 8s0 3.422.438 5.06a2.632 2.632 0 001.857 1.859c1.638.44 8.205.44 8.205.44s6.567 0 8.206-.44a2.628 2.628 0 001.856-1.859C21.5 11.422 21.5 8 21.5 8s0-3.422-.438-5.06zm-12.148 8.2V4.86l5.438 3.117-5.438 3.164z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.02ecab505726f5438eb9e426869969d4.svg";
export { ForwardRef as ReactComponent };